<template>
  <div class="bg_primary filter-wrap style-one ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-lg-3">
          <ul class="nav nav-tabs menu-tablist style-one" role="tablist">
            <li class="nav-item">
              <button
                class="nav-link active"
                data-bs-toggle="tab"
                data-bs-target="#tacos"
                type="button"
                role="tab"
              >
                Tacos
              </button>
            </li>
            <li class="nav-item">
              <button
                class="nav-link"
                data-bs-toggle="tab"
                data-bs-target="#bowls"
                type="button"
                role="tab"
              >
                Bowls
              </button>
            </li>
            <li class="nav-item">
              <button
                class="nav-link"
                data-bs-toggle="tab"
                data-bs-target="#quesadillas"
                type="button"
                role="tab"
              >
                Quesadillas
              </button>
            </li>
            <li class="nav-item">
              <button
                class="nav-link"
                data-bs-toggle="tab"
                data-bs-target="#sides"
                type="button"
                role="tab"
              >
                Sides
              </button>
            </li>
            <li class="nav-item">
              <button
                class="nav-link"
                data-bs-toggle="tab"
                data-bs-target="#desserts"
                type="button"
                role="tab"
              >
                Desserts
              </button>
            </li>
            <li class="nav-item">
              <button
                class="nav-link"
                data-bs-toggle="tab"
                data-bs-target="#drinks"
                type="button"
                role="tab"
              >
                Drinks
              </button>
            </li>
          </ul>
        </div>
        <div class="col-lg-9">
          <div class="tab-content">
            <!-- Tacos Tab -->
            <div class="tab-pane fade show active" id="tacos" role="tabpanel">
              <div class="food-list-wrap style-one">
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="https://images.pexels.com/photos/24182334/pexels-photo-24182334.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop" alt="Birria Tacos" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Birria Tacos
                        <span>(450 cal)</span>
                      </h3>
                      <p>
                        Slow-cooked halal beef birria with melted cheese, onions, cilantro, and consommé for dipping
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$12.99</h4>
                    </div>
                  </div>
                </div>
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="https://images.pexels.com/photos/1059905/pexels-photo-1059905.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop" alt="Carnitas Tacos" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Carnitas Tacos
                        <span>(380 cal)</span>
                      </h3>
                      <p>
                        Tender halal pork carnitas with pineapple salsa, onions, and cilantro on corn tortillas
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$11.99</h4>
                                          </div>
                  </div>
                </div>
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="https://images.pexels.com/photos/1640774/pexels-photo-1640774.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop" alt="Chicken Tinga Tacos" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Chicken Tinga Tacos
                        <span>(320 cal)</span>
                      </h3>
                      <p>
                        Shredded halal chicken in smoky chipotle sauce with avocado crema and cotija cheese
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$10.99</h4>
                                          </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Bowls Tab -->
            <div class="tab-pane fade" id="bowls" role="tabpanel">
              <div class="food-list-wrap style-one">
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="https://images.pexels.com/photos/1583884/pexels-photo-1583884.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop" alt="Burrito Bowl" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Burrito Bowl
                        <span>(520 cal)</span>
                      </h3>
                      <p>
                        Your choice of protein with rice, beans, lettuce, pico de gallo, cheese, and sour cream
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$13.99</h4>
                                          </div>
                  </div>
                </div>
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="https://images.pexels.com/photos/769969/pexels-photo-769969.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop" alt="Power Bowl" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Power Bowl
                        <span>(480 cal)</span>
                      </h3>
                      <p>
                        Grilled halal chicken, quinoa, black beans, corn, bell peppers, and lime vinaigrette
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$12.99</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Quesadillas Tab -->
            <div class="tab-pane fade" id="quesadillas" role="tabpanel">
              <div class="food-list-wrap style-one">
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="https://images.pexels.com/photos/1059904/pexels-photo-1059904.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop" alt="Cheese Quesadilla" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Cheese Quesadilla
                        <span>(420 cal)</span>
                      </h3>
                      <p>
                        Flour tortilla filled with melted Monterey Jack and cheddar cheese, served with guacamole
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$9.99</h4>
                                          </div>
                  </div>
                </div>
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop" alt="Chicken Quesadilla" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Chicken Quesadilla
                        <span>(580 cal)</span>
                      </h3>
                      <p>
                        Grilled halal chicken with cheese, bell peppers, and onions in flour tortilla
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$11.99</h4>
                                          </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sides Tab -->
            <div class="tab-pane fade" id="sides" role="tabpanel">
              <div class="food-list-wrap style-one">
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="https://images.pexels.com/photos/1059913/pexels-photo-1059913.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop" alt="Queso Blanco" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Queso Blanco
                        <span>(280 cal)</span>
                      </h3>
                      <p>
                        Creamy white cheese dip with roasted poblano peppers, served with tortilla chips
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$7.99</h4>
                                          </div>
                  </div>
                </div>
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="@/assets/img/food/food-1.webp" alt="Guacamole" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Fresh Guacamole
                        <span>(240 cal)</span>
                      </h3>
                      <p>
                        Fresh avocados mashed with onions, cilantro, lime, and jalapeños
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$6.99</h4>
                                          </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Desserts Tab -->
            <div class="tab-pane fade" id="desserts" role="tabpanel">
              <div class="food-list-wrap style-one">
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="https://images.pexels.com/photos/3026808/pexels-photo-3026808.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop" alt="Cinnamon Churros" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Cinnamon Churros
                        <span>(320 cal)</span>
                      </h3>
                      <p>
                        Crispy fried dough sticks coated in cinnamon sugar, served with chocolate dipping sauce
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$5.99</h4>
                                          </div>
                  </div>
                </div>
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="https://images.pexels.com/photos/291528/pexels-photo-291528.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop" alt="Tres Leches Cake" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Tres Leches Cake
                        <span>(380 cal)</span>
                      </h3>
                      <p>
                        Light sponge cake soaked in three kinds of milk, topped with whipped cream
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$6.99</h4>
                                          </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Drinks Tab -->
            <div class="tab-pane fade" id="drinks" role="tabpanel">
              <div class="food-list-wrap style-one">
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="https://images.pexels.com/photos/1438072/pexels-photo-1438072.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop" alt="Horchata" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Horchata
                        <span>(180 cal)</span>
                      </h3>
                      <p>
                        Sweet rice milk drink with cinnamon and vanilla, served over ice
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$3.99</h4>
                                          </div>
                  </div>
                </div>
                <div class="food-card style-five">
                  <div class="food-img">
                    <img src="https://images.pexels.com/photos/1028716/pexels-photo-1028716.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop" alt="Agua Fresca" />
                  </div>
                  <div class="food-info-wrap">
                    <div class="food-title">
                      <h3>
                        Agua Fresca
                        <span>(120 cal)</span>
                      </h3>
                      <p>
                        Fresh fruit water in your choice of watermelon, lime, or hibiscus flavor
                      </p>
                    </div>
                    <div class="food-price">
                      <h4>$2.99</h4>
                                          </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FranchiseMenu",
});
</script>

<style lang="scss" scoped>
.bg_primary {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #1f1f1f 100%);
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(181, 255, 0, 0.05);
    z-index: 1;
  }
  > .container {
    position: relative;
    z-index: 2;
  }
}

.filter-wrap {
  &.style-one {
    .menu-tablist {
      &.style-one {
        border: none;
        flex-direction: column;
        .nav-item {
          margin-bottom: 15px;
          .nav-link {
            background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            color: #ffffff;
            font-size: 15px;
            font-weight: 600;
            padding: 15px 20px;
            text-align: left;
            width: 100%;
            transition: all 0.3s ease;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
            &.active {
              background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);
              border-color: rgba(255, 255, 255, 0.2);
              color: #ffffff;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
              transform: translateY(-1px);
            }
            &:hover {
              border-color: rgba(255, 255, 255, 0.15);
              background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);
              transform: translateY(-1px);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
            }
          }
        }
      }
    }
    .food-list-wrap {
      &.style-one {
        .food-card {
          &.style-five {
            display: flex;
            align-items: center;
            border-radius: 16px;
            padding: 20px;
            margin-bottom: 20px;
            transition: all 0.3s ease;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
            border: 2px solid transparent;
            
            // Harmonious color variations
            &:nth-child(1) {
              background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
              border-color: rgba(181, 255, 0, 0.15);
            }
            &:nth-child(2) {
              background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
              border-color: rgba(181, 255, 0, 0.2);
            }
            &:nth-child(3) {
              background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);
              border-color: rgba(181, 255, 0, 0.25);
            }
            &:nth-child(4) {
              background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
              border-color: rgba(181, 255, 0, 0.15);
            }
            &:nth-child(5) {
              background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
              border-color: rgba(181, 255, 0, 0.2);
            }
            &:nth-child(6) {
              background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);
              border-color: rgba(181, 255, 0, 0.25);
            }
            
            &:hover {
              border-color: rgba(255, 255, 255, 0.3);
              transform: translateY(-2px);
              box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
              background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%) !important;
            }
            .food-img {
              width: 100px;
              height: 100px;
              border-radius: 12px;
              overflow: hidden;
              margin-right: 20px;
              box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.3s ease;
              }
            }
            &:hover .food-img img {
              transform: scale(1.05);
            }
            .food-info-wrap {
              flex: 1;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .food-title {
                h3 {
                  font-size: 18px;
                  font-weight: 700;
                  color: #ffffff;
                  margin-bottom: 8px;
                  a {
                    color: #ffffff;
                    text-decoration: none;
                    transition: color 0.3s ease;
                    &:hover {
                      color: #e0e0e0;
                    }
                    span {
                      font-size: 13px;
                      font-weight: 400;
                      color: #9ca3af;
                      margin-left: 8px;
                      background: rgba(255, 255, 255, 0.1);
                      padding: 2px 8px;
                      border-radius: 6px;
                    }
                  }
                }
                p {
                  font-size: 14px;
                  color: #d1d5db;
                  line-height: 1.5;
                  margin-bottom: 0;
                }
              }
              .food-price {
                text-align: right;
                h4 {
                  font-size: 20px;
                  font-weight: 700;
                  color: #ffffff;
                  margin-bottom: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .filter-wrap {
    &.style-one {
      .menu-tablist {
        &.style-one {
          margin-bottom: 30px;
          .nav-item {
            margin-bottom: 10px;
            .nav-link {
              font-size: 14px;
              padding: 12px 15px;
            }
          }
        }
      }
      .food-list-wrap {
        &.style-one {
          .food-card {
            &.style-five {
              flex-direction: column;
              text-align: center;
              .food-img {
                margin-right: 0;
                margin-bottom: 15px;
              }
              .food-info-wrap {
                flex-direction: column;
                .food-title {
                  margin-bottom: 15px;
                }
                .food-price {
                  text-align: center;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
